module.exports = __webpack_public_path__ + "img/pyramid_hip.9bef6f27.jpg";